export const USER_ACTION_START = 'user-action-start';
export const USER_ACTION_END = 'user-action-end';
export const USER_ACTION_CANCEL = 'user-action-cancel';
export const USER_ACTION_HALT = 'user-action-halt';
//# sourceMappingURL=const.js.map